import { Injectable } from '@angular/core';

const Guid = require('guid');

@Injectable()
export class SessionService {

    private sessGuid: string;

    private itemName = 'sess_guid';

    constructor() { }

    get guid(): any {
        if (this.sessGuid == null || this.sessGuid === '') {
            this.sessGuid = sessionStorage.getItem(this.itemName);

            if (this.sessGuid == null) {
                this.sessGuid = Guid.create().toString();
                sessionStorage.setItem(this.itemName, this.sessGuid);
            }
        }

        return this.sessGuid;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Service/session.service.ts
 **/